export default function () {
  // Editable content field
  const editableFields = document.querySelectorAll('.editable-content') as NodeListOf<HTMLElement>;
  if (editableFields) {
    editableFields.forEach((content) => {
      const field = content.querySelector('.editable-content-inner') as HTMLElement;
      if (field) {
        field.addEventListener("input", (e) => {
          const target = e.target as HTMLElement;
          let value = target.innerHTML.trim();

          const hiddenInput = content.querySelector('input[type="hidden"]') as HTMLInputElement;
          if (hiddenInput) {
            hiddenInput.value = value;
          }
        });
      }
    });
  }
}
